<script lang="ts" setup>
  import { type LocalNotificationBase, useInAppNotificationService } from '@/services/InAppNotificationService'
  import { DateTime } from 'luxon'
  import { computed, toRefs } from 'vue'
  //
  // const compCurrentDayWithInput = defineAsyncComponent(() => import('@/components/worktimechecker/CurrentDayWithInput.vue'))
  // const compPastDayCheck = defineAsyncComponent(() => import('@/components/worktimechecker/PastDayCheck.vue'))
  // const dialog = useDialog()

  const props = defineProps<{
    notification: LocalNotificationBase<'WORKTIMEREMINDER', { date: DateTime<true> }>
  }>()
  const { notification } = toRefs(props)
  //fix for DateTime<true> getting serialized as string
  if (!DateTime.isDateTime(notification.value.data.date)) notification.value.data.date = DateTime.fromISO(notification.value.data.date) as DateTime<true>
  const isToday = computed(() => {
    return notification.value.data.date.hasSame(DateTime.now(), 'day')
  })
  const InAppNotificationService = useInAppNotificationService()

  function clickToday() {
    // dialog.open(compCurrentDayWithInput, {
    //     props: {
    //         header: 'Heutige Arbeitszeiterfassung',
    //         modal: true,
    //         draggable: false,
    //         closable: true,
    //         blockScroll: true
    //     }
    // })
    void InAppNotificationService.setAsRead(notification.value, true)
  }

  function clickOtherDay() {
    // dialog.open(compPastDayCheck, {
    //     props: {
    //         header: 'Arbeitszeiterfassung am ' + notification.value.data.date.toLocaleString(DateTime.DATE_MED),
    //         modal: true,
    //         draggable: false,
    //         closable: true,
    //         blockScroll: true
    //     },
    //     data: {
    //         date: notification.value.data.date
    //     }
    // })

    void InAppNotificationService.setAsRead(notification.value, true)
  }
</script>

<template>
  <div
    v-if="isToday"
    @click="clickToday">
    Heutige Arbeitszeit wurde noch nicht gestartet
  </div>
  <div
    v-else
    @click="clickOtherDay">
    Das Ende der Arbeitszeit am {{ $formatter.Date(notification.data.date) }} wurde nicht erfasst
  </div>
</template>

<style scoped></style>
